const modalElement = document.getElementById('modal');

if (modalElement) {
    document.addEventListener('click', function(e) {
        const caseModal = new bootstrap.Modal(modalElement);
        const modalBody = document.getElementById('modal-body');
        if (e.target &&  e.target.closest('a') !== null && e.target.closest('a').classList.contains('show-modal')) {
            const elementWithData = e.target.closest('a');
            e.preventDefault();
            let url = elementWithData.dataset.url
            fetch(url)
            .then(function(response) {
                return response.text()
            })
            .then((html) => modalBody.innerHTML = html)
            .then(() => {
                caseModal.show();
            }).then(() => {
                initToolTips();
                initOtherCasesLink();
            })
            .catch(function(err) {
                console.log('Failed to fetch page: ', err);
            });
        }
    });
}

initOtherCasesLink = function() {
    [...document.links].forEach(element => {
        if (element.href.indexOf('/kauza/') > -1 && !element.hasAttribute('data-url')) {
            element.classList.add('show-modal');
            element.dataset.url = element.href;
            element.href = element.href + '?modal=true';
            element.dataset.bsDismiss = 'modal';
        }
    });
}

